(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var BaseModel = require('cf-base-model')
  , schemata = require('../../../service/tour/schema')()
  , moment = require('moment')

module.exports = BaseModel.extend(
  { idAttribute: '_id'

  , schemata: schemata

  , defaults: function () {
      return schemata.makeDefault()
    }

  , getStartDateFormatted: function () {
      var shows = this.getDateSortedShows()
      return shows[0] ? moment.utc(shows[0].date).format('D MMMM YYYY') : ''
    }

  , getEndDateFormatted: function () {
      var shows = this.getDateSortedShows()
        , i = shows.length - 1
      return shows[i] ? moment.utc(shows[i].date).format('D MMMM YYYY') : ''
    }

  , getDistanceMatrix: function (cb) {
      Backbone.ajax(
        { url: window.config.apiUrl + '/map/get-distance-matrix'
        , dataType: 'json'
        , contentType: 'application/json'
        , type: 'POST'
        , data: JSON.stringify(this.getJourney())
        , success: function (response) {
            cb(null, response)
          }
        , error: function (res) {
            cb(new Error(res.status, res))
          }
        }
      )
    }

  , updateDistanceMatrix: function (cb) {
      var shows = this.getDateSortedShows()
        , startLocation = this.get('startLocation')

      function clearDistances (show) {
        delete show.distance
        delete show.distanceText
        delete show.driveTime
        delete show.driveTimeText
      }

      // clear all existing distances first, thus allowing for removals
      this.attributes.shows.forEach(clearDistances)
      this.attributes.pencilledShows.forEach(clearDistances)

      this.getDistanceMatrix(function (err, matrix) {
        if (err) throw err

        matrix.forEach(function (item, i) {
          // sometimes we won't get distance info (long haul flights, etc.)
          if (!item) return

          // when there is no start location, ignore the first show
          var show = startLocation ? shows[i] : shows[i + 1]

          show.distance = item.distanceValue
          show.distanceText = item.distanceText
          show.driveTimeText = item.durationValue
          show.driveTimeText = item.durationText

        })

        cb()
      })
    }

  , getJourney: function () {
      var journey = []
        , startLocation = this.get('startLocation')
        , shows = this.getDateSortedShows()
        , show
        , nextShow
        , nextShowIndex

      if (!shows || (shows && !shows.length)) return journey

      if (startLocation) {
        journey.push(
          { origin: startLocation
          , destination: shows[0].location
          })
      }

      while (shows.length) {
        show = shows.shift()
        nextShowIndex = shows.indexOf(show) + 1

        if (!shows[nextShowIndex]) break

        nextShow = shows[nextShowIndex]
        journey.push(
          { origin: show.location
          , destination: nextShow.location
          })
      }

      return journey
    }

  , removeFreeDay: function (date) {
      var freeDays = this.get('freeDays')
        , index = freeDays.indexOf(date)

      freeDays.splice(index, 1)

      this.set('freeDays', freeDays)
    }

  , getCombinedDateSortedItems: function () {
      var items =
        this.get('shows')
          .concat(this.get('pencilledShows'))
          .concat(this.get('freeDays'))

      return items.sort(sortByDate)
    }

  , getDateSortedShows: function () {
      var shows = this.get('shows') || []
        , pencilledShows = this.get('pencilledShows') || []

      return shows.concat(pencilledShows).sort(sortByDate)
    }

  })

function sortByDate (a, b) {
  var dayA = (typeof a === 'string') ? a : a.date
    , dayB = (typeof b === 'string') ? b : b.date

  return moment.utc(dayA) - moment.utc(dayB)
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/tour/models/tour.js","/components/admin/tour/models")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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